var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError('Cannot ' + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, 'read from private field'), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => (member.has(obj) ? __typeError('Cannot add the same private member more than once') : member instanceof WeakSet ? member.add(obj) : member.set(obj, value));
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, 'write to private field'), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, 'access private method'), method);

if (!customElements.get('s-product-card')) {
  customElements.define(
    'product-card-legacy',
    class ProductCardLegacy extends HTMLElement {
      constructor() {
        super();
        this.addToCartButtons = this.querySelectorAll('[data-add-to-cart]');
      }

      connectedCallback() {
        this.attachListeners();
      }

      attachListeners() {
        if (!this.hasAttribute('data-card-active')) return;
        this.addEventListener('mouseover', () => this.fixHeight());
        this.addEventListener('mouseleave', () => this.unfixHeight());
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.unfixHeight();
        });
        if (this.addToCartButtons.length === 0) return;
        this.addToCartButtons.forEach((button) => button.addEventListener('click', () => this.addCartForProductCard(button)));
      }

      fixHeight() {
        if (window.innerWidth > 767) {
          this.style.height = `${this.clientHeight}px`;
          this.classList.add('active');
        }
      }

      unfixHeight() {
        if (window.innerWidth > 767) {
          this.style.height = `${this.clientHeight}px`;
          this.classList.remove('active');
        }
      }
      async addCartForProductCard(button) {
        let addToCartForm = button.closest('form');
        if (button.hasAttribute('data-mobile')) {
          addToCartForm = this.querySelector('form');
        }
        let formData = new FormData(addToCartForm);
        let sectionsToBundle = new Set();
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
        formData.set('sections', [...sectionsToBundle].join(','));

        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Access-Control-Allow-Origin': 'no-cors',
          },
          body: formData,
        });
        const data = await response.json();

        if (response.ok) {
          const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
          cartContent['sections'] = data['sections'];
          const items = data.hasOwnProperty('items') ? data['items'] : [data];
          addToCartForm.dispatchEvent(
            new CustomEvent('variant:add', {
              bubbles: true,
              detail: {
                items,
                cart: cartContent,
              },
            }),
          );
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:change', {
              bubbles: true,
              detail: {
                baseEvent: 'variant:add',
                cart: cartContent,
              },
            }),
          );
        }
      }
    },
  );
}
